import { render, staticRenderFns } from "./itemModifiersKiosk.vue?vue&type=template&id=359e14ef&scoped=true&"
import script from "./itemModifiersKiosk.vue?vue&type=script&lang=js&"
export * from "./itemModifiersKiosk.vue?vue&type=script&lang=js&"
import style0 from "./itemModifiersKiosk.vue?vue&type=style&index=0&id=359e14ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359e14ef",
  null
  
)

export default component.exports